import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  icon: string;
  label: string;
  value: string;
  href: string;
  description: string;
}

const ContactInfo = () => {
  const contactMethods: ContactMethod[] = [
    {
      icon: 'EnvelopeIcon',
      label: 'Email',
      value: 'contact@luminexlabradors.com',
      href: '#',
      description: 'We\'ll get back to you within 24 hours',
    },
    {
      icon: 'MapPinIcon',
      label: 'Address',
      value: 'Trenton, NJ 08601',
      href: 'https://maps.google.com/?q=40.2206,-74.7597',
      description: 'Come visit us (just call ahead to schedule)',
    },
  ];

  const businessHours = [
    { day: 'Monday - Friday', hours: '9:00 AM - 6:00 PM' },
    { day: 'Saturday', hours: '10:00 AM - 4:00 PM' },
    { day: 'Sunday', hours: 'Closed' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: 'ShareIcon', url: 'https://facebook.com' },
    { name: 'Instagram', icon: 'CameraIcon', url: 'https://instagram.com' },
    { name: 'Twitter', icon: 'ChatBubbleLeftIcon', url: 'https://twitter.com' },
  ];

  return (
    <div className="space-y-8">
      {/* Contact Methods */}
      <div className="space-y-4">
        {contactMethods.map((method) => (
          <a
            key={method.label}
            href={method.href}
            className="flex items-start gap-4 rounded-xl bg-card p-5 shadow-warm transition-smooth hover:scale-[0.98] hover:shadow-warm-md"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary/10">
              <Icon name={method.icon as any} size={24} className="text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="mb-1 font-heading text-lg font-semibold text-foreground">
                {method.label}
              </h3>
              <p className="mb-1 font-medium text-primary">{method.value}</p>
              <p className="text-sm text-muted-foreground">{method.description}</p>
            </div>
          </a>
        ))}
      </div>

      {/* Social Media */}
      <div className="rounded-xl bg-card p-6 shadow-warm">
        <h3 className="mb-4 font-heading text-lg font-semibold text-foreground">
          Connect With Us
        </h3>
        <div className="flex gap-3">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-11 w-11 items-center justify-center rounded-md bg-primary/10 text-primary transition-smooth hover:bg-primary hover:text-primary-foreground"
              aria-label={social.name}
            >
              <Icon name={social.icon as any} size={20} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;